import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

export const LegalFooter = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#E2DFD8] bg-[#F6F5F2]">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-[#718096] max-w-md" data-testid="privacy-message">{t.privacy}</p>
        <div className="flex items-center gap-5 text-xs">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="text-[#4A5568] hover:text-[#0B0E14] underline underline-offset-2 transition-colors"
          >
            {t.footer.privacy}
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="text-[#4A5568] hover:text-[#0B0E14] underline underline-offset-2 transition-colors"
          >
            {t.footer.terms}
          </Link>
        </div>
      </div>
    </footer>
  );
};
